import React, { useEffect } from 'react';
import useTranslation from '../services/translationService';

/**
 * A wrapper component that provides translation functionality
 * and handles language direction changes
 */
const TranslationWrapper = ({ children }) => {
  const { language, direction } = useTranslation();
  
  // Update document direction when language changes
  useEffect(() => {
    document.documentElement.dir = direction;
    document.documentElement.lang = language;
    
    if (direction === 'rtl') {
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
    }
  }, [language, direction]);

  return (
    <div dir={direction} className={direction === 'rtl' ? 'rtl' : ''}>
      {children}
    </div>
  );
};

export default TranslationWrapper; 